var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturelock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.999 43.334H7.582a3.25 3.25 0 0 1-3.25-3.25V11.917a3.25 3.25 0 0 1 3.25-3.25h36.833a3.25 3.25 0 0 1 3.25 3.25v13.064",
    stroke: "#00B7C0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.332 11.917a3.25 3.25 0 0 1 3.25-3.25h36.833a3.25 3.25 0 0 1 3.25 3.25v9.75H4.332v-9.75z",
    stroke: "#00B7C0",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.414 35.75h-6.5a3.25 3.25 0 0 0-3.25 3.25v2.167a3.25 3.25 0 0 0 3.25 3.25h6.5a3.25 3.25 0 0 0 3.25-3.25V39a3.25 3.25 0 0 0-3.25-3.25zM41.164 29.25a3.25 3.25 0 0 1 3.25 3.25v3.25h-6.5V32.5a3.25 3.25 0 0 1 3.25-3.25z",
    stroke: "#00B7C0",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.667 15.167a2.167 2.167 0 1 1 4.333 0 2.167 2.167 0 0 1-4.333 0zM15.167 15.167a2.167 2.167 0 1 1 4.333 0 2.167 2.167 0 0 1-4.333 0z",
    fill: "#00B7C0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturelock);
export default __webpack_public_path__ + "static/media/featurelock.a7dc4d3e1b6d65f5e587217eb3beac32.svg";
export { ForwardRef as ReactComponent };